import React, { Component } from "react";
import { Card, Icon } from "antd";
import DashboardBox from "../DashboardBox";
import DashboardCardTitle from "../DashboardCardTitle";
import BacklinksOverview from "../../Backlinks/BacklinksOverview";
import BacklinksChart from "./BacklinksChart";
import "../Dashboard.less";

export class BacklinksBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: this.props.hasData ? false : null
    };
    this.getChartData = this.getChartData.bind(this);
  }

  getChartData() {
    let chartData = [];
    if (this.props.overview && this.props.overview["total_backlinks"]) {
      chartData = this.props.overview["total_backlinks"].map((item) => ({
        c_at: item["c_at"],
        value: item["value"],
        type: "Total backlinks"
      }));
    }
    return chartData;
  }

  componentDidUpdate(prevProps, prevState) {
    const firstFetchIsInProgress =
      !prevProps.isFetching && this.props.isFetching && prevState.loading === null && this.state.loading === null;
    const fetchIsFinished = prevProps.isFetching && !this.props.isFetching;

    if (firstFetchIsInProgress && !this.props.hasData) {
      this.setState({ loading: true });
    }
    if ((firstFetchIsInProgress && this.props.hasData) || fetchIsFinished) {
      this.setState({ loading: false });
    }
  }

  render() {
    const backlinksSettingsForDashboard = ["domain_score", "total_backlinks", "referring_domains"];
    const dashboardOverviewSettings = this.props.settings.filter((setting) =>
      backlinksSettingsForDashboard.includes(setting.key)
    );

    if (this.state.loading === null) {
      return null;
    }
    if (this.state.loading === true) {
      return (
        <div className="dashboard-backlinks-box">
          <DashboardBox />
        </div>
      );
    }
    if (this.state.loading === false) {
      return (
        <div className="dashboard-backlinks-box">
          <Card
            data-cy="backlinks-box"
            title={<DashboardCardTitle title="Backlinks overview" description={"Over the last 7 days"} />}
            extra={
              <div className="card-link flexbox align-center" onClick={() => this.props.push("/backlinks")}>
                <span>View all backlinks</span>
                <Icon type="right" />
              </div>
            }>
            <BacklinksOverview
              isLoading={this.props.isLoading}
              settings={dashboardOverviewSettings}
              overview={this.props.overview}
              showChart={false}
            />
            <BacklinksChart chartData={this.getChartData()} />
          </Card>
        </div>
      );
    }
  }
}

export default BacklinksBox;
